<template>
  <tr>
    <td v-for="(header, i) in headers" :key="i">
      <div v-if="typeof row[header.value] === 'boolean'">
        <span v-if="row[header.value]">
          <v-icon color="green">check</v-icon>
        </span>
        <span v-else>
          <v-icon color="red">close</v-icon>
        </span>
      </div>
      <div v-if="typeof row[header.value] === 'string'">{{row[header.value] || '-'}}</div>
      <div v-if="header.text=='Actions'" class="justify-end layout px-0">
        <v-btn flat color="grey" icon @click="editDialog = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>
    </td>

    <!-- EDIT DIALOG -->
    <v-dialog v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false" lazy>
      <edit-billing-period :billingPeriod="row" @close="editDialog = false"></edit-billing-period>
    </v-dialog>
  </tr>
</template>

<script>
import EditBillingPeriod from '@/modules/settings/billingPeriods/editBillingPeriod'
export default {
  props: {
    row: Object,
    headers: Array,
  },
  components: {
    EditBillingPeriod,
  },
  data() {
    return {
      loading: false,
      editDialog: false,
    }
  },
}
</script>

<style>
</style>